export const ARCHIVE_MODE_ENABLED =
  process.env.REACT_APP_ARCHIVE_MODE === "true";

export const ARCHIVE_BANNER_MESSAGE =
  process.env.REACT_APP_ARCHIVE_BANNER_MESSAGE ||
  "EKCloud V1 Arşiv Paneli — Bu sistem yalnızca geçmiş kayıtları görüntülemek için kullanılmaktadır. Yeni kayıt, düzenleme, silme, mail gönderimi ve otomasyon işlemleri kapalıdır.";

export const ARCHIVE_ALLOWED_PATH_PREFIXES = [
  "/",
  "/kvkk",
  "/payment/success",
  "/payment/fail",
  "/customer-list",
  "/support",
  "/tasks",
  "/jobs",
  "/jobs/details",
  "/marketingChase",
  "/tally",
  "/panel/customers/add",
  "/customer/information/edit",
];

export const ARCHIVE_BLOCKED_ACTION_PATTERNS = [
  /(^|\s)ekle($|\s)/i,
  /olu[sş]tur/i,
  /d[üu]zenle/i,
  /g[üu]ncelle/i,
  /(^|\s)sil($|\s)/i,
  /g[öo]nder/i,
  /kaydet/i,
  /y[üu]kle/i,
  /aktar/i,
  /transfer/i,
  /ata/i,
  /tamamla/i,
  /whats?app/i,
  /sms/i,
  /mail/i,
  /email/i,
  /ödeme al/i,
  /odeme al/i,
];

export function isArchivePathAllowed(pathname) {
  return ARCHIVE_ALLOWED_PATH_PREFIXES.some((prefix) => {
    if (prefix === "/") {
      return pathname === "/";
    }

    return pathname === prefix || pathname.startsWith(`${prefix}/`);
  });
}
